import { render, staticRenderFns } from "./RecordDetails.vue?vue&type=template&id=51c6b00e&scoped=true&"
import script from "./RecordDetails.vue?vue&type=script&lang=js&"
export * from "./RecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./RecordDetails.vue?vue&type=style&index=0&id=51c6b00e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c6b00e",
  null
  
)

export default component.exports